import { render, staticRenderFns } from "./SponsoredPostsFilters.vue?vue&type=template&id=df6340b0&scoped=true&"
import script from "./SponsoredPostsFilters.vue?vue&type=script&lang=js&"
export * from "./SponsoredPostsFilters.vue?vue&type=script&lang=js&"
import style0 from "./SponsoredPostsFilters.vue?vue&type=style&index=0&id=df6340b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6340b0",
  null
  
)

export default component.exports